module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Italic.9ef62df9.woff2";